import { LOGICAL_HEIGHT, LOGICAL_WIDTH } from "./types";

export class CanvasSurface {
  readonly context: CanvasRenderingContext2D;
  private pixelRatio = 1;

  constructor(readonly canvas: HTMLCanvasElement) {
    const context = canvas.getContext("2d", { alpha: false });
    if (!context) throw new Error("Canvas 2D is not supported");
    this.context = context;
    this.resize();
  }

  resize(): void {
    this.pixelRatio = Math.min(window.devicePixelRatio || 1, 2);
    const width = Math.round(LOGICAL_WIDTH * this.pixelRatio);
    const height = Math.round(LOGICAL_HEIGHT * this.pixelRatio);
    if (this.canvas.width !== width) this.canvas.width = width;
    if (this.canvas.height !== height) this.canvas.height = height;
  }

  prepare(background = "#071218"): CanvasRenderingContext2D {
    this.resize();
    this.context.setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);
    this.context.clearRect(0, 0, LOGICAL_WIDTH, LOGICAL_HEIGHT);
    this.context.fillStyle = background;
    this.context.fillRect(0, 0, LOGICAL_WIDTH, LOGICAL_HEIGHT);
    return this.context;
  }
}

export async function toggleFullscreen(element: HTMLElement): Promise<void> {
  if (document.fullscreenElement) {
    await document.exitFullscreen();
    return;
  }
  await element.requestFullscreen();
}
